import { toTitleCase } from 'helpers';
import { getDeviceStatusColor } from 'store/services/device-status';
import styles from './DeviceStatus.module.scss';

export interface DeviceStatusProps {
    status: string;
}

const DeviceStatus = (props: DeviceStatusProps) => {
    return (
        <div
            className={styles.DeviceStatus}
            data-testid="DeviceStatus"
            style={{
                backgroundColor: getDeviceStatusColor(props.status),
                color: 'black',
            }}
        >
            {toTitleCase(props.status ?? '')}
        </div>
    );
};

export default DeviceStatus;
